import React, { useEffect, useState } from "react";

import label from "../../../administration/labels/administration_en.json";

import GenerateInterviewScheduleList from "../../../interviewProcess/components/interviewSchedule/generateInterviewScheduleList";
import GenerateInterviewAttendeeList from "../../../interviewProcess/components/interviewSchedule/generateInterviewAttendeeList";
import GenerateInterviewAbsenteeList from "../../../interviewProcess/components/interviewSchedule/generateInterviewAbsenteeList";
import InterviewListWithToken from "../../../interviewProcess/components/interviewSchedule/InterviewListWithToken";
import InterviewPostPreferencesList from "../../../interviewProcess/components/interviewSchedule/InterviewPostPreferencesList";
import AllotmentChartReport from "../../../interviewProcess/components/interviewSchedule/allotmentChartReport";
import InterviewScheduleList from "../../../interviewProcess/components/interviewSchedule/interviewScheduleList";
import CriteriaForChecking from "../../../interviewProcess/components/interviewSchedule/CriteriaForChecking";
import RevisedInterviewSchedule from "../../../interviewProcess/components/interviewSchedule/revisedinterviewSchedule";

const Interview = () => {

  const [stepName, setName] = useState("generateinterviewschedulelist");


  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.Interview} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "generateinterviewschedulelist"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="generateinterviewschedulelist"
              id="generateinterviewschedulelist-tab"
              onClick={() => setName("generateinterviewschedulelist")}
              data-toggle="tab"
              role="tab"
              aria-controls="generateinterviewschedulelist"
              aria-selected="false"
            >
              <span>Schedule</span>
            </a>
          </li>

          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "generateinterviewattendee"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="generateinterviewattendee"
              id="generateinterviewattendee-tab"
              onClick={() => setName("generateinterviewattendee")}
              data-toggle="tab"
              role="tab"
              aria-controls="generateinterviewattendee"
              aria-selected="false"
            >
              <span>Attendee</span>
            </a>
          </li>

          <li className="nav-item" key="3">
            <a
              href="#"
              className={
                stepName === "generateinterviewabsentee"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="generateinterviewabsentee"
              id="generateinterviewabsentee-tab"
              onClick={() => setName("generateinterviewabsentee")}
              data-toggle="tab"
              role="tab"
              aria-controls="generateinterviewabsentee"
              aria-selected="false"
            >
              <span>Absentee</span>
            </a>
          </li>

          <li className="nav-item" key="4">
            <a
              href="#"
              className={
                stepName === "interviewlistwithtoken"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="interviewlistwithtoken"
              id="interviewlistwithtoken-tab"
              onClick={() => setName("interviewlistwithtoken")}
              data-toggle="tab"
              role="tab"
              aria-controls="interviewlistwithtoken"
              aria-selected="false"
            >
              <span>Token List</span>
            </a>
          </li>

          <li className="nav-item" key="5">
            <a
              href="#"
              className={
                stepName === "interviewpostpreferenceslist"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="interviewpostpreferenceslist"
              id="interviewpostpreferenceslist-tab"
              onClick={() => setName("interviewpostpreferenceslist")}
              data-toggle="tab"
              role="tab"
              aria-controls="interviewpostpreferenceslist"
              aria-selected="false"
            >
              <span>Post Preferences</span>
            </a>
          </li>

          <li className="nav-item" key="6">
            <a
              href="#"
              className={
                stepName === "allotmentchartreport"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="allotmentchartreport"
              id="allotmentchartreport-tab"
              onClick={() => setName("allotmentchartreport")}
              data-toggle="tab"
              role="tab"
              aria-controls="allotmentchartreport"
              aria-selected="false"
            >
              <span>Allotment Chart</span>
            </a>
          </li>
          <li className="nav-item" key="7">
            <a
              href="#"
              className={
                stepName === "criteriaForChecking"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="criteriaForChecking"
              id="criteriaForChecking-tab"
              onClick={() => setName("criteriaForChecking")}
              data-toggle="tab"
              role="tab"
              aria-controls="criteriaForChecking"
              aria-selected="false"
            >
              <span>Criteria For Checking</span>
            </a>
          </li>

          <li className="nav-item" key="8">
            <a
              href="#"
              className={
                stepName === "interviewschedulelist"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="interviewschedulelist"
              id="interviewschedulelist-tab"
              onClick={() => setName("interviewschedulelist")}
              data-toggle="tab"
              role="tab"
              aria-controls="interviewschedulelist"
              aria-selected="false"
            >
              <span>Schedule List</span>
            </a>
          </li>

          <li className="nav-item" key="9">
            <a
              href="#"
              className={
                stepName === "revisedinterviewschedule"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="revisedinterviewschedule"
              id="revisedinterviewschedule-tab"
              onClick={() => setName("revisedinterviewschedule")}
              data-toggle="tab"
              role="tab"
              aria-controls="revisedinterviewschedule"
              aria-selected="false"
            >
              <span>Revised Schedule</span>
            </a>
          </li>

        </ul>


        <div className="tab-content border border-light" id="myTabContent">

          <div
            className={
              stepName === "generateinterviewschedulelist"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="generateinterviewschedulelist"
            role="tabpanel"
            aria-labelledby="generateinterviewschedulelist-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <GenerateInterviewScheduleList key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "generateinterviewattendee"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="generateinterviewattendee"
            role="tabpanel"
            aria-labelledby="generateinterviewattendee-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <GenerateInterviewAttendeeList key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "generateinterviewabsentee"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="generateinterviewabsentee"
            role="tabpanel"
            aria-labelledby="generateinterviewabsentee-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <GenerateInterviewAbsenteeList key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "interviewlistwithtoken"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="interviewlistwithtoken"
            role="tabpanel"
            aria-labelledby="interviewlistwithtoken-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <InterviewListWithToken key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "interviewpostpreferenceslist"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="interviewpostpreferenceslist"
            role="tabpanel"
            aria-labelledby="interviewpostpreferenceslist-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <InterviewPostPreferencesList key={stepName} />
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "allotmentchartreport"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="allotmentchartreport"
            role="tabpanel"
            aria-labelledby="allotmentchartreport-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <AllotmentChartReport key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "criteriaForChecking"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="criteriaForChecking"
            role="tabpanel"
            aria-labelledby="criteriaForChecking-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <CriteriaForChecking key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "interviewschedulelist"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="interviewschedulelist"
            role="tabpanel"
            aria-labelledby="interviewschedulelist-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <InterviewScheduleList key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "revisedinterviewschedule"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="revisedinterviewschedule"
            role="tabpanel"
            aria-labelledby="revisedinterviewschedule-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <RevisedInterviewSchedule key={stepName} />
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default Interview;